
import { ChevronDown, ChevronUp } from "lucide-react";
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "@/components/ui/collapsible";
import { Component } from "@/utils/types/componentTypes";
import { ComponentItem } from "./ComponentItem";

interface ComponentGroupProps {
  groupName: string;
  components: Component[];
  isExpanded: boolean;
  onToggle: () => void;
  onDragStart: (event: React.DragEvent, component: Component) => void;
}

export function ComponentGroup({ 
  groupName, 
  components, 
  isExpanded, 
  onToggle, 
  onDragStart 
}: ComponentGroupProps) {
  return (
    <Collapsible>
      <CollapsibleTrigger 
        onClick={onToggle}
        className="flex items-center justify-between w-full px-3 py-2 text-sm font-medium text-sidebar-foreground hover:bg-sidebar-accent"
      >
        <div className="flex items-center gap-2">
          {groupName} ({components.length})
        </div>
        {isExpanded ? <ChevronUp className="h-4 w-4" /> : <ChevronDown className="h-4 w-4" />}
      </CollapsibleTrigger>
      
      {isExpanded && (
        <CollapsibleContent className="space-y-1 px-2 pb-2">
          {components.map((component) => (
            <ComponentItem
              key={component.id}
              component={component}
              onDragStart={onDragStart}
            />
          ))}
        </CollapsibleContent>
      )}
    </Collapsible>
  );
}
